import layout from "~/layout/App/Index.vue";
import auth from "../middleware/auth";

const profileRoutes = {
  path: "/profile",
  redirect: "/profile/info",
  component: layout,
  name: "profile",
  meta: {
    middleware: auth
  },
  children: [
    {
      path: "info",
      component: () => import("~/views/Profile/Info"),
      name: "profile.info",
      meta: {
        middleware: auth,
        breadcrumb: [
          { name: 'user.settings.personal_information', route: "profile.info" },
          { name: "tabs.my_details" }
        ],
      }
    },
    {
      path: "notifications",
      component: () => import("~/views/Profile/Notifications"),
      name: "profile.notifications",
      meta: {
        middleware: auth,
        breadcrumb: [
          { name: 'user.settings.personal_information', route: "profile.info" },
          { name: "tabs.notification_settings" }
        ],
      }
    },
    {
      path: "security",
      component: () => import("~/views/Profile/Security"),
      name: "profile.security",
      meta: {
        middleware: auth,
        breadcrumb: [
          { name: 'user.settings.personal_information', route: "profile.info" },
          { name: "tabs.security_settings" }
        ],
      }
    },
    {
      path: "settings",
      component: () => import("~/views/Profile/Settings"),
      name: "profile.settings",
      meta: {
        middleware: auth,
        breadcrumb: [
          { name: 'user.settings.personal_information', route: "profile.info" },
          { name: "tabs.profile_settings" }
        ],
      }
    }
  ]
};

export default profileRoutes;
